// extracted by css-extract-rspack-plugin
export default {"downloadToolbar":"usBOeE4ttzY_Q920","tableWrapper":"XcXQta8Hhl4XC7lI"};